module.exports = {"version":"0.2.4"}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 22
// module chunks = 0